// extracted by mini-css-extract-plugin
export default {"stories":"Stories_stories__OEPGb","card":"Stories_card__KRzqJ"};